import { atom } from 'recoil';

let notiDetailInfo = atom<any>({
  key: 'notiDetailInfo',
  default: {},
});

export { notiDetailInfo };
